(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multirows-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector("header"); // Select the website's header
    const cards = document.querySelectorAll(".custom-card");

    function updateStickyPosition() {
        let headerHeight = header ? header.offsetHeight + 20 : 100; // Detect header height + add spacing

        document.documentElement.style.setProperty('--custom-header-height', `${headerHeight}px`);
    }

    function handleScroll() {
        let offset = window.innerHeight * 0.5;

        cards.forEach((card) => {
            const rect = card.getBoundingClientRect();

            if (rect.top <= offset && rect.bottom > offset) {
                card.classList.add("sticky");
            } else {
                card.classList.remove("sticky");
            }
        });
    }

    // Run on load & window resize
    updateStickyPosition();
    window.addEventListener("resize", updateStickyPosition);
    window.addEventListener("scroll", handleScroll);
});

  } catch(e) { console.error(e); }
})();
})();
